import React, { useEffect, useState } from "react";
import "./style.css";
import caseSummaryIcon from "../../../Assets/Icons/caseSummary-icon.svg";
import Edit from "../../../Assets/Icons/Edit.png";
import patientReportOutcomesIcon from "../../../Assets/Icons/patientReportedOutcomes-icon.svg";
import { usePatientContext } from "../../../Context/PatientContext";
import { getDDMMYY } from "../../../Helpers/index";
import EditPatientModal from "../Modal/EditPatientDetails";

const PatientSummary = (props) => {
  const { handleScreenSwitch, handleSharingHistory } = props;
  const { patientDetails, patientTimeline } = usePatientContext();
  const [isEditPatientSummaryModalOpen, setEditPatientSummaryModalOpen] =
    useState(false);

  /**
   * Data to be displayed for cancer
   */
  const cancerInfo = [
    // {
    //   id: 1,
    //   label: "Histology Subtype",
    //   text: patientDetails?.diagnosis?.histologicalSubtype,
    //   fileid: patientDetails?.diagnosis?.recordURL,
    // },
    {
      id: 2,
      label:
        patientDetails?.tumorCharacterisation?.length > 0 &&
        patientDetails?.tumorCharacterisation[
          patientDetails?.tumorCharacterisation?.length - 1
        ]?.description &&
        "Tumor size",
      text:
        patientDetails?.tumorCharacterisation?.length > 0 &&
        patientDetails?.tumorCharacterisation[
          patientDetails?.tumorCharacterisation?.length - 1
        ]?.description,
      fileid:
        patientDetails?.tumorCharacterisation?.length > 0 &&
        patientDetails?.tumorCharacterisation[
          patientDetails?.tumorCharacterisation?.length - 1
        ]?.recordURL,
    },
    {
      id: 3,
      label:
        patientDetails?.genomicFindings?.length > 0 &&
        patientDetails?.genomicFindings[
          patientDetails?.genomicFindings?.length - 1
        ]?.name &&
        "Molecular Mutation",
      text:
        patientDetails?.genomicFindings?.length > 0 &&
        patientDetails?.genomicFindings[
          patientDetails?.genomicFindings?.length - 1
        ]?.name,
      fileid:
        patientDetails?.genomicFindings?.length > 0 &&
        patientDetails?.genomicFindings[
          patientDetails?.genomicFindings?.length - 1
        ]?.recordURL,
    },
    {
      id: 4,
      label:
        patientDetails?.biomarkerFindings?.length > 0 &&
        patientDetails?.biomarkerFindings[
          patientDetails?.biomarkerFindings?.length - 1
        ]?.name &&
        "Biomarker",
      text:
        patientDetails?.biomarkerFindings?.length > 0 &&
        patientDetails?.biomarkerFindings[
          patientDetails?.biomarkerFindings?.length - 1
        ]?.name,
      fileid:
        patientDetails?.biomarkerFindings?.length > 0 &&
        patientDetails?.biomarkerFindings[
          patientDetails?.biomarkerFindings?.length - 1
        ]?.recordURL,
    },
  ];

  const patientSummary = {
    dateofDiagnosis: {
      label: "Diagnosis Date",
      text: getDDMMYY(patientDetails?.diagnosis?.dateofDiagnosis),
      value: patientDetails?.diagnosis?.dateofDiagnosis,
      fileid: patientDetails?.diagnosis?.recordURL,
    },
    location: {
      label: "Location",
      text: patientDetails?.diagnosis?.location,
      fileid: patientDetails?.diagnosis?.recordURL,
    },
    cancerType: {
      label: "Cancer Type",
      text: patientDetails?.diagnosis?.cancerType,
      fileid: patientDetails?.diagnosis?.recordURL,
    },
    histologicalSubtype: {
      label: "Histology Subtype",
      text: patientDetails?.diagnosis?.histologicalSubtype,
      fileid: patientDetails?.diagnosis?.recordURL,
    },
    stage: {
      label: "Stage",
      text:
        (patientDetails?.staging?.length > 0 &&
          patientDetails?.staging[patientDetails?.staging?.length - 1]
            ?.stage) ||
        "",
      fileid:
        patientDetails?.staging?.length > 0 &&
        patientDetails?.staging[patientDetails?.staging?.length - 1]?.recordURL,
    },
    cancerInfo: cancerInfo,
  };

  useEffect(() => {}, [patientDetails]);

  return (
    // White bg frame
    <div className="patient-summary-frame">
      {/* patient summary frame */}
      <div className="patient-summary-heading-frame">
        <h6 className="h6-400 dark-grey">Patient Summary</h6>
        {/* buttons frame */}
        <div className="summary-buttons-frame">
          <button
            className="summary-buttons"
            onClick={() => handleScreenSwitch()}
          >
            <img
              src={caseSummaryIcon}
              className="summary-button-icons"
              alt="summary-button-icon"
            />
            Case Summary
          </button>
          {/* Disabled for phase 1 */}
          {/* <button className="summary-buttons">
            <img
              src={patientReportOutcomesIcon}
              className="summary-button-icons"
              alt="summary-button-icon"
            />
            Patient Reported Outcomes
          </button> */}
          {/* Disabled for phase 1 */}
          {/* <button
            className="summary-buttons"
            onClick={() => handleSharingHistory()}
          >
            Sharing History
          </button> */}
          <img
            className="edit-icon"
            alt="edit-icon"
            src={Edit}
            onClick={() => setEditPatientSummaryModalOpen(true)}
          />
        </div>
      </div>

      {/* Information is classified into primary, secondary and tertiary in patient summary */}
      {/* All Information texts have different text size and frame size */}
      {/* Primary depicts larger and tertiary depicts lower level info and small info */}
      <p className="body1 dark-grey">
        Diagnosis Date: {getDDMMYY(patientDetails?.diagnosis?.dateofDiagnosis)}{" "}
        | Location: {patientDetails?.diagnosis?.location}
      </p>
      <h5 className="h5-400 blue">{patientDetails?.diagnosis?.cancerType} </h5>
      <div className="secondary-info-frame">
        <p className="body1 dark-grey">Stage</p>
        <p className="body1 primary-bg">
          {(patientDetails?.staging?.length > 0 &&
            patientDetails?.staging[patientDetails?.staging?.length - 1]
              ?.stage) ||
            " "}
        </p>
        {/* <p className="body1 dark-grey">
          {patientDetails?.genomicFindings?.name}
        </p> */}
      </div>
      <div className="tertiary-info-container">
        <div className="tertiary-info-frame">
          <p className="body1 dark-grey">Histology Subtype</p>
          <p className="body2 medium-grey">
            {patientDetails?.diagnosis?.histologicalSubtype}
          </p>
        </div>
        <div className="tertiary-info-bottom-frame">
          {patientSummary.cancerInfo?.map((item) => (
            <div key={item.id} className="tertiary-info-frame">
              <p className="body1 dark-grey">{item.label}</p>
              <p className="body2 medium-grey">{item.text}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Show Edit Patient Details modal when edit button is clicked */}
      {isEditPatientSummaryModalOpen && (
        <EditPatientModal
          type="summary"
          isOpen={isEditPatientSummaryModalOpen}
          onClose={() => setEditPatientSummaryModalOpen(false)}
          patientSummary={patientSummary}
        />
      )}
    </div>
  );
};

export default PatientSummary;
